<div class="header">
    <h1 class="text-center">How</h1>
</div>

<div class="door-step-bg">
    <div class="door_step_container">
        <div class="door_step_info text-white">
            <h6 class="text-center door_step_hindhi_title"> करे मुद्दे की बात? </h6>
            <h3 class="text-center doorstep_title"> How to get yourDesiCart @ Your Doorstep? </h3>

            <div class="container">
                <div class="row">
                     <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_one">
                        <div class="text-center"> 
                            <div class="numberCircle">1</div>
                        </div>

                        <h6 class="circle_title"> Signup </h6>

                        <p class="door_step_para"> Get yourDesiCart India Locker
                            Address to store all your
                            shopping items. </p>
                     </div>
                     <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_two">
                        <div class="text-center"> 
                            <div class="numberCircle">2</div>
                        </div>

                        <h6 class="circle_title"> Shop </h6>

                        <p class="door_step_para"> 
                            Shop from any store in India & ship to your Locker. Get package picked up from friends/family in
                            India. Avail custom tailoring and other concierge services. </p>
                     </div>
                     <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_three">
                        <div class="text-center"> 
                            <div class="numberCircle">3</div>
                        </div>

                        <h6 class="circle_title"> Relax </h6>

                        <p class="door_step_para"> We will Track your Indian shopping orders, Inspect them, Consolidate
                            into one
                            package to save
                            costs and Ship them to your doorstep anywhere in the world. </p>
                     </div>
                     <div class="col-md-6 col-lg-6 col-xl-3 text-center circle_four">
                        <div class="text-center"> 
                            <div class="numberCircle">4</div>
                        </div>

                        <h6 class="circle_title"> Receive </h6>

                        <p class="door_step_para"> Receive at your doorstep in 3-10 days. Enjoy yourDesiCart sitting
                            miles away
                            from
                            India ! </p>
                     </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>